import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { LeistungstextPage } from './leistungstext';

@NgModule({
  declarations: [
    LeistungstextPage,
  ],
  imports: [
    IonicPageModule.forChild(LeistungstextPage),
  ],
})
export class LeistungstextPageModule {}



// WEBPACK FOOTER //
// ./src/pages/leistungstext/leistungstext.module.ts